module.exports = __webpack_public_path__ + "static/media/46 - Cheryl Lynn - Got to Be Real (Single Version).199d0a6c.mp3";